module.exports = __webpack_public_path__ + "img/13e-doc-emissao-textos.57ae9303.png";